import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

import Link from 'components/common/A'
import { InfoModal } from 'components/common/Modal'
import { PhoneSVG } from 'components/common/SVGElements'
import { VENDER_AD_WARNING_TEXT } from 'components/pages/Vender/constants'

const ContactPhoneModal = ({
  open,
  onClose,
  phone,
  extension,
  shortname,
  onPhoneClick,
  onCallClick,
  phoneLinkId,
  callButtonId,
}) => {
  if (!phone) return null

  const phoneLink = `tel:${phone}${extension ? `,,${extension}` : ''}`

  return (
    <InfoModal open={open} onClose={onClose}>
      <Typography variant="h6" px={5} pt={5} fontWeight="fontWeightBold">
        廠商聯絡電話
      </Typography>
      <Box p={5}>{VENDER_AD_WARNING_TEXT}</Box>
      <Box display="flex" alignItems="center" px={5} pb={2}>
        <PhoneSVG $color="text.minus2" />
        <Typography ml={2}>
          <Link id={phoneLinkId} href={phoneLink} onClick={onPhoneClick}>
            {phone}
            {extension && <span>{` #${extension}`}</span>}
          </Link>
        </Typography>
      </Box>
      {shortname && (
        <Box px={5}>
          <Typography variant="paraBodySmall" color="text.minus2">
            聯繫時，歡迎告知 {shortname} 您是從「信義居家」看到資訊。
          </Typography>
        </Box>
      )}
      <Box display="flex" justifyContent="flex-end" gap={2.5} p={5}>
        <Button
          variant="outlined"
          onClick={onClose}
          size="small"
          sx={{ color: 'text.minus1', borderColor: 'text.minus1' }}
        >
          關閉
        </Button>
        <Button
          id={callButtonId}
          size="small"
          variant="contained"
          color="primary"
          href={phoneLink}
          onClick={onCallClick}
        >
          撥打電話
        </Button>
      </Box>
    </InfoModal>
  )
}

export default ContactPhoneModal
